import { useState } from 'react';
import { SingleSelectButtonGroup, Stack, Text } from '@stitch-fix/mode-react';
import { useUpdateLookResemblanceAnswerMutation, UpdateLookResemblanceAnswerMutation } from './graphql/updateLookResemblanceAnswer';
import { Look } from '../../../../types/definitions/vendor/graphql-schema.d';
import { useToast } from '../../../../utils/contexts/toast-provider';
const options: {
  value: 'yes' | 'no';
  label: string;
}[] = [{
  value: 'yes',
  label: 'Yes'
}, {
  value: 'no',
  label: 'No'
}];
export type LookResemblanceAnswerProps = {
  look: Pick<Look, 'id' | 'resemblesMeAnswer'>;
  onChange?: (value: string) => void;
};
const getInitialValue = (resemblesMeAnswer: boolean | null | undefined): 'yes' | 'no' | undefined => {
  if (resemblesMeAnswer == null) return undefined; // handles both null + undefined

  return resemblesMeAnswer ? 'yes' : 'no';
};
const LookResemblanceAnswer = ({
  look,
  onChange
}: LookResemblanceAnswerProps) => {
  const {
    addToast
  } = useToast();
  const [value, setValue] = useState<'yes' | 'no' | undefined>(getInitialValue(look.resemblesMeAnswer));
  const [visionLookResemblanceSubmit] = useUpdateLookResemblanceAnswerMutation({
    onCompleted: (data: UpdateLookResemblanceAnswerMutation) => {
      const result = data.visionLookResemblanceSubmit?.result;
      if (result?.__typename === 'VisionLookResemblanceSubmitError') {
        // eslint-disable-next-line no-console
        console.error(result.message);
      }
      if (result?.__typename === 'VisionLookResemblanceSubmitError') {
        addToast({
          message: result.message,
          status: 'error'
        });
      }
    }
  });
  const handleChange = (newValue: 'yes' | 'no') => {
    setValue(newValue);
    onChange?.(newValue);
    visionLookResemblanceSubmit({
      variables: {
        input: {
          lookId: look.id,
          resemblesMeAnswer: newValue === 'yes'
        }
      }
    });
  };
  return <Stack spacing={1}>
      <Text as="span" setting="title-small">
        Do you like this image?
      </Text>
      <SingleSelectButtonGroup name={`look-resemblance-${look.id}`} options={options} value={value} variant="pill" onChange={handleChange} />
    </Stack>;
};
export default LookResemblanceAnswer;